import { createSelector } from '@reduxjs/toolkit';
import { selectSecurity } from '../../store/selectors';

export const selectListState = createSelector(selectSecurity, (securityState) => securityState.list);
export const selectParameters = createSelector(selectListState, (listState) => listState.parameters);
export const selectSecurityList = createSelector(selectListState, (listState) => listState?.securities);
